import React, { useEffect } from "react";
import navigationEventTracker from "../tracker/navigationEventTracker";
import i18n from "../../../../../utils/ChrI18n";
import useCustomizeCookiePreferencesModal from "../../../CookieConsent/CustomizeCookiePreferences/custom/useCustomizeCookiePreferencesModal";
import { handleManageCookiesButtonClick } from "../../../CookieConsent/utils";
// This component is a special built, designed footer component in consideration of AWS Code of Conduct document
const SideBarFooter = ({ tabs }) => {

  const hasExacltyThreeLegalDocuments = tabs.legalDocuments && tabs.legalDocuments.length === 3 ? true : false;
  const cookieData = {...tabs.cookies.data, consentConstants: JSON.parse(tabs.cookies.data.consentConstants)}
  const { modalControls, modalContent } = useCustomizeCookiePreferencesModal(cookieData);

  useEffect(() => {
    const manageCookiesElement = document.getElementById("cjs-manage-cookies");
    manageCookiesElement && manageCookiesElement.addEventListener("click", () => handleManageCookiesButtonClick(modalControls.showModal));
  }, []);

  return (
    <>
      { !hasExacltyThreeLegalDocuments && tabs.legalDocuments && tabs.legalDocuments.length == 2 && (
        <div className={`side-bar-footer-container ${tabs.workingOnBehalf ? "working-on-behalf": ""}`}>
          <div className="side-bar-footer-content">
            <div className="terms-privacy">
              { tabs.legalDocuments[0] && <a target="_blank" onClick={()=> { navigationEventTracker(tabs.legalDocuments[0].trackingInfo) }} href={tabs.legalDocuments[0].url }>{i18n.t("footer.terms")}</a>}
              <span>·</span>
              { tabs.legalDocuments[1] && <a target="_blank" onClick={()=> { navigationEventTracker(tabs.legalDocuments[1].trackingInfo) }} href={tabs.legalDocuments[1].url }>{i18n.t("chronus_privacy_policy_v1.chronus_llc.privacy")}</a> }
            </div>
            {
              cookieData && cookieData.canShowManageCookiesLink &&
              <div className="pt-1">
                { tabs.cookies && <a onClick={() => handleManageCookiesButtonClick(modalControls.showModal)} className="text-decoration-underline">{tabs.cookies.label}</a> }
              </div>
            }
            <div className="pt-1">
              {tabs.poweredBy && tabs.poweredBy.showPoweredBy && (
                <a target="_blank" onClick={()=> { navigationEventTracker(tabs.poweredBy.trackingInfo) }} className="cui-powered-by-label text-decoration-none" href={tabs.poweredBy.url}>
                  {tabs.poweredBy.label}
                </a>
              )}
            </div>
          </div>
        </div>
      )}
      { hasExacltyThreeLegalDocuments && (
        <div className={`aws-terms-privacy ${tabs.workingOnBehalf ? "working-on-behalf": ""}`}>
          <span>
            <a target="_blank" onClick={()=> { navigationEventTracker(tabs.legalDocuments[0].trackingInfo) }} href={tabs.legalDocuments[0].url}>{tabs.legalDocuments[0].label}</a> <span> | </span>
            <a target="_blank" onClick={()=> { navigationEventTracker(tabs.legalDocuments[1].trackingInfo) }} href={tabs.legalDocuments[1].url}>{tabs.legalDocuments[1].label}</a> <span> | </span>
            <a target="_blank" onClick={()=> { navigationEventTracker(tabs.legalDocuments[2].trackingInfo) }} href={tabs.legalDocuments[2].url}>{tabs.legalDocuments[2].label}</a>
          </span>
          <div className="aws-powered-by">
            {
              tabs.poweredBy && tabs.poweredBy.showPoweredBy && (
                <a target="_blank" onClick={()=> { navigationEventTracker(tabs.poweredBy.trackingInfo) }} className="cui-powered-by-label text-decoration-none" href={tabs.poweredBy.url}>
                  {tabs.poweredBy.label}
                </a>
            )}
          </div>
        </div>
      )}
      {modalContent}
    </>
  );
};

export default SideBarFooter;
